import { ColoursObj, MainButton, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { ChatUnavailable } from '../../assets/illustrations/ChatUnavailable'
import { useBoundStore } from '../../state/bound.store'
export const NotFoundPage = () => {
    const { IDtoken } = useBoundStore(
        useShallow((s) => {
            return { IDtoken: s.IDtoken }
        })
    )
    return (
        <Stack
            style={{
                backgroundColor: ColoursObj.shades.shade5,
            }}
        >
            <Stack
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100vw',
                    height: '100%',
                    paddingTop: '20vh',
                    gap: '16px',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <ChatUnavailable />
                <Stack
                    style={{
                        gap: '16px',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="mobileH1" textAlign={'center'}>
                        Page not found
                    </Typography>

                    <MainButton
                        text="Go back"
                        onClick={() => {
                            if (IDtoken) {
                                window.pushPath('/')
                            } else {
                                window.pushPath('/authentication/signin')
                            }
                        }}
                        style={{ width: 'fitContent' }}
                    />
                </Stack>
            </Stack>
        </Stack>
    )
}
